import { Card, CardList, Title, Wrapper } from "./styles";
import { StyledButton, } from "components/generic";
import HP_people1 from "assets/images/HP_people1.png";
import HP_people2 from "assets/images/HP_people2.png";
import HP_people3 from "assets/images/hiw_s_3.png";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom"
interface ICardComponent {
    image: string;
    title: string;
    text: string;
    buttonText: string;
    link: string;
    i: number;
}

const CardComponent: React.FC<ICardComponent> = ({ image, text, buttonText, title, link, i }) => {
    return (
        <Card i={i === 2}>
            <img src={image} />
            <span id='bold'>
                {title}
            </span>
            <p>
                {text}
            </p>
            <StyledButton outline={true}>
                <NavLink to={link}>
                    {buttonText}
                </NavLink>
            </StyledButton>
        </Card>
    )
}

export const WeAreHereSection = () => {

    const { t, i18n } = useTranslation('home');

    const cardsData = [
        {
            image: HP_people1,
            title: t('forHosts'),
            text: t('weAreHere.text1'),
            buttonText: t('buttons.moreAboutRentingOut'),
            link: `/${i18n.language}/hospita`
        },
        {
            image: HP_people2,
            title: t('forStudents'),
            text: t('weAreHere.text2'),
            buttonText: t('buttons.moreAboutRent'),
            link: `/${i18n.language}/students`
        },
        {
            image: HP_people3,
            title: t('forCities'),
            text: t('weAreHere.text3'),
            buttonText: t('buttons.contact'),
            link: `/${i18n.language}/partners`
        },
    ]

    return (
        <Wrapper>
            <div>
                <Title>{t('weAreHere.title.p1')}{' '}<span>{t('weAreHere.title.p2')}</span></Title>
                <CardList>
                    {
                        cardsData.map((props, i) => <CardComponent {...props} i={i} />)
                    }
                </CardList>
            </div>
        </Wrapper>
    )
}
